export default {"src":"/_next/static/media/mission.12a1f53f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};